module.exports = __webpack_public_path__ + "img/hero-image-landing-2.be7f6a6c.png";